import countriesData from '../data/countries.json';

const COUNTRIES = countriesData.countries || [];
export const TOTAL_COUNTRIES = COUNTRIES.length;

/**
 * Get continent for a country code (same definition as mobile share-world-stats).
 * @param {string} code - ISO 2-letter country code (e.g. "US", "FR")
 * @returns {string|null} Continent name or null
 */
export function getContinentForCountry(code) {
  if (!code || typeof code !== 'string') return null;
  const normalized = code.toUpperCase().trim().slice(0, 2);
  const country = COUNTRIES.find((c) => c.code === normalized);
  return country && country.continent ? country.continent : null;
}

/**
 * Derive world %, countries count, and continents count from visited country codes.
 * Uses same "world" definition as mobile (TOTAL_COUNTRIES from countries data).
 * @param {string[]} countryCodes - Array of ISO country codes
 * @returns {{ worldPercentage: number, countriesCount: number, continentsCount: number }}
 */
export function calculateStats(countryCodes) {
  if (!Array.isArray(countryCodes) || countryCodes.length === 0) {
    return {
      worldPercentage: 0,
      countriesCount: 0,
      continentsCount: 0,
    };
  }
  const countriesCount = countryCodes.length;
  const worldPercentage = TOTAL_COUNTRIES > 0
    ? (countriesCount / TOTAL_COUNTRIES) * 100
    : 0;
  const continents = new Set(
    countryCodes
      .map(getContinentForCountry)
      .filter(Boolean)
  );
  const continentsCount = continents.size;
  return {
    worldPercentage,
    countriesCount,
    continentsCount,
  };
}
